import type { ShareUrl as ShareUrlType } from '@wix/ambassador-devcenter-v1-share-url/types';
import { ActivationStatus } from '@wix/ambassador-devcenter-v1-share-url/types';
import type { VersionType } from './dev-center-share-url.service';

export class ShareUrl {
  constructor(private readonly shareUrl: ShareUrlType | undefined) {}

  get appId(): string {
    return this.shareUrl?.appId ?? '';
  }

  get activisionStatus(): 'ENABLED' | 'DISABLED' {
    return this.shareUrl?.activationStatus ?? ActivationStatus.DISABLED;
  }
  get versionType(): VersionType | undefined {
    return this.shareUrl?.versionType;
  }
}
